import { forwardRef, type SelectHTMLAttributes } from 'react';

import { FontIcon, type FontIconName } from '../FontIcon';
import '../Input/Input.styl';
import './Select.styl';

type Props = SelectHTMLAttributes<HTMLSelectElement> & { icon?: FontIconName; invalid?: boolean };

/** Native select styled like the text fields, with its own chevron and an optional leading glyph. */
export const Select = forwardRef<HTMLSelectElement, Props>(function Select({ icon, invalid = false, className, children, ...rest }, ref) {
  const classes = ['a-input', 'a-select'];
  if (invalid) classes.push('a-input--invalid');
  if (className) classes.push(className);
  const select = (
    <select ref={ref} className={classes.join(' ')} aria-invalid={invalid || undefined} {...rest}>
      {children}
    </select>
  );
  if (!icon) return select;
  return (
    <span className={`a-input__wrap a-select__wrap${invalid ? ' a-input__wrap--invalid' : ''}${rest.disabled ? ' a-input__wrap--disabled' : ''}`}>
      <span className="a-input__slot">
        <FontIcon name={icon} />
      </span>
      {select}
    </span>
  );
});
